export enum EnCareType {
    intercorrencia,
    conduta,
    progresso,
    sinalvital,
    medicacao
}
